<template>
    <div class="row">
        <div class="col-12 pb-2">
            <div class="d-md-flex justify-content-between align-items-center pb-2">
                <TitleComponent title="Resumen de la compra"/>
                <div v-if="!compra_finalizada">
                    <Button @click="$emit('cambiarDatos')" class="mr-2">Modificar datos</Button>
                    <Button @click="$emit('comenzarDeNuevo')">Comenzar de nuevo</Button>
                </div>
            </div>
        </div>
        <div class="col-12 mt-4">
            <div class="row">
                <div v-for="(parcela, index) in datosParcelas" :key="parcela.id" class="col-12 bg-light mb-3 p-2">
                    <h3>
                        <strong class="d-flex align-items-center">
                            <span class="text-primary pr-4">PARCELA {{ ++index }}. </span>
                            <span class="pr-4"><strong> Parcela Nº</strong> {{ parcela.numero }} </span>
                            <div class="pr-4">
                                PRECIO:
                                <template v-if="parseFloat(parcela.descuento) > 0">
                                    <del>{{ parseFloat(parcela.precioSeleccionado.precio) | formatear_precio }}</del>
                                    <span class="text-primary">
                                        ({{ calcularPrecioConDescuento(parcela.precioSeleccionado.precio, parcela.descuento) | formatear_precio }} / -{{ parcela.descuento }}%)
                                    </span>
                                </template>
                                <template v-else>
                                    <span>{{ parseFloat(parcela.precioSeleccionado.precio) | formatear_precio }}</span>
                                </template>
                            </div>
                        </strong>
                    </h3>
                </div>
                <div class="col-12 mt-2 mb-3 mb-md-0">
                    <h3>
                        <strong>Precio Total: </strong>
                        <template v-if="hayDescuentos">
                            <del>{{ precioOriginalTotal | formatear_precio }}</del>
                            <span class="text-primary ml-2">
                                {{ precioTotal | formatear_precio }}
                            </span>
                        </template>
                        <template v-else>
                            {{ precioTotal | formatear_precio }}
                        </template>
                    </h3>
                </div>
                <div class="col-12">
                    <h3><strong>FORMA DE PAGO: <span class="display-4">{{ nombreMetodoPago }}</span></strong></h3>
                </div>
                <div v-if="datosParcelas.metodo_pago === 1" class="col-12">
                    <PaymentCalculator class="mb-3" :amountDue="precioTotal" v-if="precioTotal > 0" />
                </div>
            </div>
            
            <div class="col-12 pl-0 mt-2" v-if="!compra_finalizada">
                <Button @click="procesarCompra">
                    Finalizar compra
                </Button>
                <div class="col-12" v-if="loading" style="height: 120px">
                    <LoaderComponent/>
                </div>
            </div>
            <div class="col-12 pl-0 mt-2" v-else>
                <template v-if="!loading">
                    <div>
                        <template >
                            <Button type="button" target="_blank" @click="abrirPdf">
                                DESCARGAR PARCELAS EN PDF
                            </Button>
                        </template>
                    </div>
                </template>
                <div class="col-12" v-else style="height: 120px">
                    <LoaderComponent/>
                </div>
            </div>
            <div class="col-12 mt-3 px-0" v-if="compra_finalizada && !loading">
                <div class="alert alert-success alert-dismissible mb-0">
                    <h5><i class="icon fas fa-check mb-2"></i> ¡Compra finalizada correctamente!</h5>
                    <template >
                        <Button @click="$emit('nuevaCompra')">Comprar de nuevo</Button>
                    </template>
                </div>
            </div>

        </div>
    </div>
</template>
  
<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import PaymentCalculator from '@/components/common/PaymentCalculator';

    export default {
        props: {
            datosParcelas: {
                type: Array,
                required: true
            },
            cart_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                compra_finalizada: false,
                qr_codes: null,
                api_base: process.env.VUE_APP_API_BASE,
                url_pdf: null
            }
        },
        methods: {
            calcularPrecioConDescuento(precio, descuento) {
                const p = parseFloat(precio);
                const d = parseFloat(descuento);
                return p - (p * d / 100);
            },
            abrirPdf() {
                if (this.pdf_url) {
                    window.open(this.pdf_url, '_blank');
                } else {
                    this.$toast.error('No se ha generado el PDF de las parcelas.');
                }
            },
            procesarCompra() {
                this.loading = true;

                const params = {
                    lista_id: this.lista.id,
                    cart_id: this.cart_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.parcelas.carrito.procesar-pedido'), params).then(res => {
                    this.compra_finalizada = true;
                    this.qr_codes = res.data.qr_codes;
                    this.pdf_url = res.data.url_pdf;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            precioTotal() {
                if (!this.datosParcelas || !this.datosParcelas.length) return 0;

                return this.datosParcelas.reduce((total, parcela) => {
                    const precio = parseFloat(parcela.precioSeleccionado.precio);
                    const descuento = parseFloat(parcela.descuento || 0);
                    const precioConDescuento = descuento > 0 ? precio - (precio * descuento / 100) : precio;
                    return total + precioConDescuento;
                }, 0);
            },
            precioOriginalTotal() {
                if (!this.datosParcelas || !this.datosParcelas.length) return 0;
        
                return this.datosParcelas.reduce((total, parcela) => {
                    const precio = parseFloat(parcela.precioSeleccionado.precio);
                    return total + precio;
                }, 0);
            },
            hayDescuentos() {
                return this.datosParcelas.some(parcela => parseFloat(parcela.descuento || 0) > 0);
            },
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            metodos_pago() {
                let metodos_de_pago = this.teatro.metodos_pago_eventos.slice().filter(metodo_pago => metodo_pago.show_taquilla);
                return metodos_de_pago;
            },
            nombreMetodoPago() {
                const metodo = this.metodos_pago.find(m => m.id === this.datosParcelas.metodo_pago);
                return metodo ? metodo.nombre : '';
            }
        },
        created() {
            this.datosParcelas.forEach(parcela => {
                if (typeof parcela.descuento === 'undefined') {
                    parcela.descuento = 0;
                }
            });
        },
        components: {
            TitleComponent,
            PaymentCalculator
        }
    }
</script>